const Urls = [
    'https://es-update.digiwin.com/installer/SCP/SCP.Desktop.Setup.exe',//台湾服务云管家链接
    'https://es-repo.digiwincloud.com.cn/installer/SCP.Desktop.Setup.exe',//大陆服务云管家链接
    //'http://es-update.digiwincloud.com.cn/installer/SCP.Desktop.Setup.exe',//大陆服务云管家链接
    'https://es-update.digiwin.com/installer/EsClient/EsCloudInstall.zip',//台湾驻派员链接
    'https://es-repo.digiwincloud.com.cn/installer/EsClient/EsCloudInstall.zip',//大陆驻派员链接
    //'http://es-update.digiwincloud.com.cn/installer/EsClient/EsCloudInstall.zip',//大陆驻派员链接
]
const area = {
    0: 'es-ygj.digiwincloud.com',
    1: 'es-ygj.digiwincloud.com.cn'
}
export const exeDownUrl = {
    'es-ygj.digiwincloud.com': 'https://es-update.digiwin.com/installer/SCP/SCP.Desktop.Setup.exe',//台湾服务员管家
    'es-ygj.digiwincloud.com.cn': 'https://es-repo.digiwincloud.com.cn/installer/SCP.Desktop.Setup.exe'//'http://es-update.digiwincloud.com.cn/installer/SCP.Desktop.Setup.exe'//大陆服务云管家
};
export const zhupyDownUrl = {
    'es-ygj.digiwincloud.com': 'https://es-update.digiwin.com/installer/Esclient/EsCloudIstall.zip',//台湾驻派员链接
    'es-ygj.digiwincloud.com.cn': 'https://es-repo.digiwincloud.com.cn/installer/Esclient/EsCloudIstall.zip',//'http://es-update.digiwincloud.com.cn/installer/Esclient/EsCloudIstall.zip',//大陆驻派员链接
};
export const introDownUrl = {
    //'es-ygj.digiwincloud.com':'https://es-update.digiwin.com/installer/SCP/鼎新服務雲管家使用說明.docx',//台湾云管家说明
    //'es-ygj.digiwincloud.com.cn':'http://es-update.digiwincloud.com.cn/installer/鼎捷服务云管家操作手册.docx',//大陆云管家说明

    'es-ygj.digiwincloud.com': 'https://es-update.digiwin.com/installer/SCP/鼎新服務雲管家使用說明.pdf',//台湾云管家说明
    'es-ygj.digiwincloud.com.cn': 'https://es-repo.digiwincloud.com.cn/installer/鼎捷服务云管家操作手册.pdf',//'http://es-update.digiwincloud.com.cn/installer/鼎捷服务云管家操作手册.pdf',//大陆云管家说明
    //註:Word檔在對應路徑下，以有日期之檔案為主，現行最新的為_20250207.docx
}
